/**
 * Primeiro elemento focavel da pagina. Sem ele, quem navega por teclado ou
 * leitor de tela atravessa o cabecalho inteiro em toda troca de tela.
 * Fica escondido ate receber foco (WCAG 2.4.1).
 */
export function PularParaConteudo() {
  return (
    <a
      href="#conteudo"
      className="so-leitor focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:inline-flex focus:items-center focus:rounded focus:bg-[var(--color-primary)] focus:px-4 focus:py-3 focus:text-[var(--color-text-inverse)] focus:[clip-path:none] focus:[block-size:auto] focus:[inline-size:auto] focus:[position:fixed] focus:[white-space:normal]"
    >
      Pular para o conteúdo
    </a>
  );
}
